












import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop() public caption: string;
  @Prop() public icon: string;
  @Prop({default:null}) public sc: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({default:false}) public disabled: boolean;
  @Prop({default:null}) public perm: string;
 @Prop({default:'right'}) public placement: string;

  public get isDisabled() {
    return this.disabled || !this.$api.perms.hasMenuPermission(this.perm);
  }
  public get titleSC(){
    if (this.sc==null) return this.$translate(this.caption);
    else return this.$translate(this.caption) +'('+ this.sc +')';
  }
 //#region　フォーカス制御～Read以外の場合に確認ダイアログを表示する
  public created() {
    // if (this.sc != null) document.body.addEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.add(this.sc, this.onClick);    
  }
  public mounted() {
    if(this.tooltip) this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip,this.placement);
  }

  public destroyed() {
    // if (this.sc != null) document.body.removeEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.remove(this.sc, this.onClick);    
  }

  // public onKeyDown(ev: KeyboardEvent){
  //   if (ev.key == this.sc){
  //     ev.preventDefault();
  //     this.OnClick();
  //   }
  // }

  public onClick(): boolean {
    //GA4イベント(エディタの業務処理ボタンもしくは明細グリッドの業務処理ボタン)
    if (this.$el.parentElement && this.$el.parentElement.classList.contains('cx_appevent_enabled')) this.$api.issueGA4event(this.$route.path,this.caption);    
    // if (this.$api.perms.hasMenuPermission(this.perm) && this.enabled) {
    //   this.$emit('click');
    // }
    this.$root.$emit('bv::hide::tooltip');
    this.$emit('click');    
    return true;
  }

  // @Emit('click')
  // public OnClick() { }

  @Emit('mousedown')
  public onMouseDown(){}
  @Emit('mouseup')
  public onMouseUp(){}  
}
